var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdvantages9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7516 29.0594C59.5721 29.0594 58.1191 30.5124 58.1191 32.6919V69.0162C58.1191 71.1957 59.5721 72.6486 61.7516 72.6486C63.931 72.6486 65.384 71.1957 65.384 69.0162V32.6919C65.384 30.5124 63.931 29.0594 61.7516 29.0594Z",
    fill: "#58A291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2218 39.9568C45.0423 39.9568 43.5894 41.4098 43.5894 43.5892V69.0162C43.5894 71.1957 45.0423 72.6487 47.2218 72.6487C49.4012 72.6487 50.8542 71.1957 50.8542 69.0162V43.5892C50.8542 41.4098 49.4012 39.9568 47.2218 39.9568Z",
    fill: "#58A291"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.692 50.854C30.5125 50.854 29.0596 52.307 29.0596 54.4864V69.0162C29.0596 71.1956 30.5125 72.6486 32.692 72.6486C34.8715 72.6486 36.3244 71.1956 36.3244 69.0162V54.4864C36.3244 52.307 34.8715 50.854 32.692 50.854Z",
    fill: "#58A291"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1622 61.7513C15.9828 61.7513 14.5298 63.2043 14.5298 65.3838V69.0162C14.5298 71.1957 15.9828 72.6486 18.1622 72.6486C20.3417 72.6486 21.7947 71.1957 21.7947 69.0162V65.3838C21.7947 63.2043 20.3417 61.7513 18.1622 61.7513Z",
    fill: "#58A291"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0164 0H54.8499C52.6704 0 51.2174 1.45297 51.2174 3.63243C51.2174 5.81189 52.6704 7.26486 54.8499 7.26486H60.2985L35.2347 31.9654L15.9829 25.7903C14.1666 25.427 12.3504 26.1535 11.6239 27.9697L0.726634 53.0335C0.00014782 54.8497 0.726634 57.0292 2.54285 57.7557C4.35907 58.4822 6.53853 57.7557 7.26501 55.9395L17.0726 33.7816L35.2347 39.5935C36.6877 39.9568 37.7774 39.5935 38.8672 38.867L65.3839 12.3503V17.7989C65.3839 19.9784 66.8369 21.4314 69.0164 21.4314C71.1958 21.4314 72.6488 19.9784 72.6488 17.7989V3.63243C72.6488 1.81622 70.8326 0 69.0164 0Z",
    fill: "#58A291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdvantages9);
export default __webpack_public_path__ + "static/media/icon-advantages-9.489fc7bea459aafef963b7a6ea733116.svg";
export { ForwardRef as ReactComponent };